import { render } from "./PortfolioCovers.vue?vue&type=template&id=1719e330&scoped=true"
import script from "./PortfolioCovers.vue?vue&type=script&lang=js"
export * from "./PortfolioCovers.vue?vue&type=script&lang=js"

import "./PortfolioCovers.vue?vue&type=style&index=0&id=1719e330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1719e330"]])

export default __exports__